import { render, staticRenderFns } from "./PopupAIRiskReductions.vue?vue&type=template&id=42dd0ff6&scoped=true"
import script from "./PopupAIRiskReductions.vue?vue&type=script&lang=js"
export * from "./PopupAIRiskReductions.vue?vue&type=script&lang=js"
import style0 from "./PopupAIRiskReductions.vue?vue&type=style&index=0&id=42dd0ff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dd0ff6",
  null
  
)

export default component.exports